module.exports = __webpack_public_path__ + "img/Sustainable2.26313cf4.jpg";